
export const environment = {
  production: false,
  environmentName: 'Staging',
    apiUrl: 'https://dev-pb-api-aperture.gspann.com/preboarding',
    keycloackUrl: 'https://dev-auth-aperture.gspann.com',
    redirectUri: 'https://dev-pb-aperture.gspann.com',
    apertureUri: 'https://uat-aperture.gspann.com'
};